export default __webpack_public_path__ + "static/media/hyperhidrosis.f57ee9a0.jpg";